import { classifyAttachment } from '@components/Attachments/attachmentKind';
import { PDF_PREVIEW_MAX_BYTES } from './PdfViewer.constants';

/** A size of 0 means unknown, which could be any size, so it never previews. */
export const canPreviewPdf = (name: string, fileSize: number, contentType = ''): boolean =>
  classifyAttachment(contentType, name) === 'pdf' && fileSize > 0 && fileSize <= PDF_PREVIEW_MAX_BYTES;
